import { appInfo } from "@/common/data"; 
export default [
    {
            path: "/00a136fd440acfa73be8ba1d",
            children: [
              {
                path: "/00a136fd440acfa73be8ba1d",
                name: "baice25.gazettes",
                component: () => import("@/views/baice/twf/gazette/list.vue"),
                meta: {
                  title:
                    appInfo?.type == "codemsi"
                      ? "SAISSCE 2025 Gazettes"
                      : "BAICE 2025 Gazettes",
                  authRequired: true,
                  acc: ["y86393"],
                },
              },
              {
                path: "/007a13bcf4971a12b3243025",
                name: "baice25.pendinggazettereq",
                component: () =>
                  import("@/views/baice/twf/gazette/pendingrequests.vue"),
                meta: {
                  title:
                    appInfo?.type == "codemsi"
                      ? "SAISSCE 2025 Pending Gazette Requests"
                      : "BAICE 2025 Pending Gazette Requests",
                  authRequired: true,
                  acc: ["y41541"],
                },
              },
              {
                path: "/011029aeaf4da445c1fe174a",
                name: "baice25.uploadgazette",
                component: () => import("@/views/baice/twf/gazette/upload.vue"),
                meta: {
                  title:
                    appInfo?.type == "codemsi"
                      ? "Upload SAISSCE 2025 Gazette"
                      : "Upload BAICE 2025 Gazette",
                  authRequired: true,
                  acc: ["y61647"],
                },
              },
              {
                path: "/016ec794841a964450b74d24",
                name: "baice25.uploadedgazettes",
                component: () =>
                  import("@/views/baice/twf/gazette/uploaded-gazette.vue"),
                meta: {
                  title:
                    appInfo?.type == "codemsi"
                      ? "Uploaded SAISSCE 2025 Gazettes"
                      : "Uploaded BAICE 2025 Gazettes",
                  authRequired: true,
                  acc: ["y10535"],
                },
              },
              {
                path: "/01bdf5f61f5368c53f12f431/:er?",
                name: "baice25.gazette",
                component: () => import("@/views/baice/twf/gazette/vgazette.vue"),
                meta: {
                  title:
                    appInfo?.type == "codemsi"
                      ? "Print SAISSCE Gazette"
                      : "Print BAICE Gazette",
                  authRequired: true,
                  acc: ["y63307"],
                },
              },
            ],
          },

]